import { useMemo } from 'react';

import { CATEGORY, QualityControl } from '@/api';
import { useIsDDFeatureFlagEnabled } from '@/core/data-dog';

export function useFilteredQualityControl(data: QualityControl | undefined) {
  const isHideHeartHealthQualityReviewEnabled = useIsDDFeatureFlagEnabled(
    'FCT_HIDE_HEART_HEALTH_QUALITY_REVIEW',
  );

  return useMemo(() => {
    if (!data) {
      return data;
    }

    if (isHideHeartHealthQualityReviewEnabled) {
      return {
        ...data,
        categories: data.categories.filter(
          (category) => category.category !== CATEGORY.HEART_HEALTH_ASSESSMENT,
        ),
      };
    }

    return data;
  }, [data, isHideHeartHealthQualityReviewEnabled]);
}
